module.exports = __webpack_public_path__ + "static/media/17.Chicken Clucks.9764014f.mp3";